import React from "react";
import "tippy.js/dist/tippy.css";
import IconButton from "./IconButton";
import { useTranslation } from 'react-i18next';

const EditButton = ({show = true, onClick, className}) => {

    const { t } = useTranslation();

    return (
        <>
            <IconButton
                show={show}
                className={className}
                variant="outline-primary"
                onClick={onClick}
                icon="fa-edit"
                tooltip={t("common.edit")}
            />
        </>
    );
};


export default EditButton;